import React, { Fragment, useEffect, useState } from "react";
import "./NewTabulator.scss";
import CellValue from "./CellValue";
import {
  formatToPersianAddComma,
  parseToEnRemoveComma,
} from "../../utils/CommaSeparator";

const NewTabulator = (props) => {
  let { columns, data, events } = props;

  if (!columns) columns = [];
  if (!data) data = [];

  const [selectedRow: {}, setSelectedRow] = useState({});

  const myColumns: string[] = [...columns];
  const myData: any[] = [...data];

  let titles: any[] = [];
  let fields: any[] = [];
  let editors: any[] = [];
  let bottomCalcs: any[] = [];
  let bottomCalcValues: any[] = [];
  let formatters: any[] = [];
  let visibles: any[] = [];
  let cellClicks: any[] = [];
  let cellEditeds: any[] = [];
  let maxWidths: any[] = [];
  let styles: any[] = [];

  myColumns.forEach((myColumn, index) => {
    let {
      title,
      field,
      visible,
      editor,
      bottomCalc,
      formatter,
      cellClick,
      cellEdited,
      style,
    } = myColumn;

    titles.push(title);
    fields.push(field);
    editors.push(editor);
    bottomCalcs.push(bottomCalc);
    bottomCalcValues.push(0);
    formatters.push(formatter);
    visibles.push(visible);
    cellClicks.push(cellClick);
    cellEditeds.push(cellEdited);
    styles.push(style);
  });

  const singleRowClick = (singleRowData) => {
    events?.rowClick && setSelectedRow(singleRowData);
    events?.rowClick(singleRowData);
  };
  const singleRowDoubleClick = (singleRowData) => {
    events?.rowDoubleClick(singleRowData);
  };

  useEffect(() => {

    if (events?.selectedRow) {
      const key = events.selectedRow ? Object?.keys(events?.selectedRow)[0] : undefined
      const value = events.selectedRow ? Object?.values(events?.selectedRow)[0] : undefined
      let tempSelectedRow;
      events.selectedRow && key && value && myData.forEach((singleRowData, index) => {

        if (singleRowData[key] === value) {
          setSelectedRow(singleRowData)
          tempSelectedRow = singleRowData
        }
      })


      tempSelectedRow && events?.rowClick && events?.rowClick(tempSelectedRow);
    }


  }, [JSON.stringify(events?.selectedRow), JSON.stringify(myData)]);

  return (
    <div className={`${props.className} NewTabulator`}>
      <div {...props} className={"position-relative"}>
        <ul>
          {myColumns.map((myColumn, index) => {
            return (
              <React.Fragment key={index}>
                {myColumn.visible !== false && (
                  <li style={styles[index]}>{myColumn.title}</li>
                )}
              </React.Fragment>
            );
          })}
        </ul>
        <>
          {myData.map((singleRowData, index) => (
            <React.Fragment key={index}>
              <ul
                className={
                  JSON.stringify(singleRowData) === JSON.stringify(selectedRow)
                    ? "rowSelected"
                    : ""
                }
                onClick={() => singleRowClick(singleRowData)}
                onDoubleClick={() => singleRowDoubleClick(singleRowData)}
              >
                {fields.map((field, indexField: number) => {
                  const value = singleRowData[field];

                  const editor = editors[indexField];
                  const formatter = formatters[indexField];
                  const cellClick = cellClicks[indexField];
                  const visible = visibles[indexField];
                  const bottomCalc = bottomCalcs[indexField];
                  if (bottomCalc !== undefined) {
                    bottomCalcValues[indexField] +=
                      +parseToEnRemoveComma(value);
                    const keys = Object.keys(singleRowData);
                    // bottomCalcValues[keys[indexField]] = +parseToEnRemoveComma(value)
                    bottomCalcValues[keys[indexField]] = +value;
                  }
                  const cellEdited = cellEditeds[indexField];
                  const style = styles[indexField];

                  // NOTE: I must Expand Cell Object WhenEver I need :)
                  let cell = {
                    getData: () => {
                      return singleRowData;
                    },
                    getValue: () => {
                      return value;
                    },
                  };
                  if (visible === false) {
                    return null;
                  }
                  return (
                    <li
                      key={indexField + "" + index}
                      onClick={cellClick && ((e) => cellClick(e, cell))}
                      style={style}
                    >
                      <CellValue
                        number={indexField}
                        cell={cell}
                        editor={editor}
                        formatter={formatter}
                        bottomCalc={bottomCalc}
                        value={value}
                        cellEdited={cellEdited}
                      />
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
          ))}
        </>
      </div>
      <div className={"bottom__calc__section"} style={{ position: "relative" }}>
        <ul style={{ backgroundColor: "#fff" }}>
          {fields.map((field, indexField) => {
            const bottomCalc = bottomCalcs[indexField];
            const formatter = formatters[indexField];

            const visible = visibles[indexField];
            if (visible === false) {
              return null;
            }

            const value = bottomCalcValues[indexField]
            let cell = {
              getData: () => {
                return bottomCalc;
              },
              getValue: () => {
                return value;
              },
            };
            return (
              <li style={styles[indexField]} key={indexField}>
                {/*{bottomCalc && bottomCalcValues[indexField]}*/}
                {/*{bottomCalc && formatToPersianAddComma(bottomCalcValues[indexField])}*/}
                {bottomCalc && <>
                  <CellValue
                    number={indexField}
                    cell={cell}
                    editor={editors[indexField]}
                    formatter={formatter}
                    // bottomCalc={bottomCalc}
                    value={bottomCalc}
                    // cellEdited={cellEdited}
                  />
                </>}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default NewTabulator;
